import React from "react";
import { View } from "react-native";
import Skeletons from "./Skeletons";

const GoLiveUpperDropdown = () => {
  return (
    <View
      style={[
        {
          flexDirection: "row",
          paddingTop: 5,
          paddingBottom: 25,
          columnGap: 10,
        },
      ]}
    >
      <View>
        <Skeletons
          height={15}
          width={"175px"}
          style={{
            borderRadius: 10,
            marginBottom: 10,
          }}
        />
        <Skeletons
          height={40}
          width={"175px"}
          style={{
            borderRadius: 10,
          }}
        />
      </View>
      <View>
        <Skeletons
          height={15}
          width={"175px"}
          style={{
            borderRadius: 10,
            marginBottom: 10,
          }}
        />
        <Skeletons
          height={40}
          width={"175px"}
          style={{
            borderRadius: 10,
          }}
        />
      </View>
    </View>
  );
};

export default GoLiveUpperDropdown;
